const Backbone = require('backbone');
const gtmHelper = require('../../../../lib/helpers/gtm_helper');

const AccordionList = Backbone.View.extend({
	/**
	 * @param {{multiExpand?: boolean, exception?: string}} options
	 */
	initialize(options = {}) {
		this.options = options;
	},

	originalEvents: {
		'click .item .js-expand': 'toggle'
	},

	/**
	 * These should be left empty so child views can add events
	 */
	childViewEvents: {},

	events() {
		return Object.assign({}, this.originalEvents, this.childViewEvents);
	},

	/**
	 * @param {JQuery.ClickEvent} event
	 */
	toggle(event) {
		if (this.options.exception && $(event.target).hasClass(this.options.exception)) {
			return;
		}
		event.preventDefault();
		event.stopPropagation();
		const $currentTarget = $(event.currentTarget);
		const $currentItem = $currentTarget.closest('.item'),
			isActive = $currentItem.hasClass('active');
		let $item, $itemUl;

		if (this.options.multiExpand) {
			$item = $currentTarget.closest('.js-group');
			$itemUl = $currentTarget.closest('.item').find('.js-group-list');
		} else {
			$item = this.$('.item').filter('.active');
			$itemUl = $item.find('ul');
		}

		if (!this.options.multiExpand || (this.options.multiExpand && isActive)) {
			$itemUl.css('max-height', 0);

			$itemUl.attr('style', '');
			$item.removeClass('active');
			Backbone.trigger('accordion_list:collapse', $item);
		}

		if (!isActive) {
			this._triggerShippingFacetTracking(
				$currentItem
					.find('.js-group-display-name')
					.text()
					.replace(/\s/g, '')
			);
			$currentItem.addClass('active');
			Backbone.trigger('accordion_list:expand', $item);
		}

		Backbone.trigger('accordion_list:toggle', $currentItem.data('groupname'));
	},

	_triggerShippingFacetTracking: function(prop) {
		const trackingProp = {
			linkName: `${prop} DropDown`
		};

		gtmHelper.fireEvent({
			event: 'generic-click-tracking',
			linkName: trackingProp
		});

		Backbone.trigger('track:link', trackingProp);
	}
});
module.exports = AccordionList;
